import { HttpService, resolveService } from "@reco-m/core";

export class BiR2040ArticleService extends HttpService {
    protected parkPromise: any;

    constructor() {
        super("servicemanage/article");
    }


}

export const r2040ArticleService = resolveService(BiR2040ArticleService);